import { Component } from '@angular/core';
import { TermsAndConditionsPanelComponent } from '../terms-and-conditions-panel/terms-and-conditions-panel.component';

@Component({
  selector: 'app-legal-info-panel',
  templateUrl: './legal-info-panel.component.html',
  styleUrl: './legal-info-panel.component.scss',
  imports: [TermsAndConditionsPanelComponent],
  standalone: true,
})
export class LegalInfoPanelComponent {}
